import { render, staticRenderFns } from "./supplusStorage.vue?vue&type=template&id=5067325a&scoped=true&"
import script from "./supplusStorage.vue?vue&type=script&lang=js&"
export * from "./supplusStorage.vue?vue&type=script&lang=js&"
import style0 from "./supplusStorage.vue?vue&type=style&index=0&id=5067325a&prod&scoped=true&lang=less&"
import style1 from "./supplusStorage.vue?vue&type=style&index=1&id=5067325a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067325a",
  null
  
)

export default component.exports